import {
  axiosPatch,
  axiosPost,
} from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";
import axios from "axios";

async function SubmitMedia({ btnLoading, setBtnLoading, companyLink, file }) {
  if (!btnLoading) {
    setBtnLoading(true);
    try {
      //upload pdf here...

      //   const formData = new FormData();
      //   formData.append("file", file);
      //   formData.append("editionNumber", editionNumber);
      //   formData.append("startups", startups);
      //   formData.append("alumnis", alumnis);
      //   formData.append("countries", countries);
      //   formData.append("funding", funding);
      //   formData.append("caption", caption);
      //   console.log("firm data", formData);
      //   await axiosPatch({
      //     endpoint: ApiConstants.UPDATE_IMPACTCARD,
      //     formData: formData,
      //   });

      const formData = new FormData();
      formData.append("file", file);
      formData.append("companyLink", companyLink ?? "#");
      await axiosPost({
        endpoint: ApiConstants.ADD_MEDIA,
        formData: formData,
      });
      // console.log("response = ", response);
      setBtnLoading(false);
      return true;
    } catch (error) {
      console.log("error = ", error);
      setBtnLoading(false);
      if (!error?.response) {
        console.log("No server response.");
        // console.log("Login credit Expired.\nPlease Login Again!!!");
      } else if (
        error.response?.status === 404 ||
        error.response?.status === 401
      ) {
        console.log("Server Error !!! Try Logging in again.");
      } else {
        console.log("Login credit Expired.\nPlease Login Again!!!");
      }
      return false;
    }
  }
}

export default SubmitMedia;
